/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from "vue-tsx-support";
import {Component,Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import _ from 'lodash'
import './frameContentBg.less'
import { createBEM } from 'src/util/bem';
import Spin from 'src/types/iview/Spin';
let bem = createBEM('frame-content-bg');

interface FrameContentBgPropsI{
    showCorner?: boolean
    radius?: boolean
    loading?: boolean
}
@Component
export default class FrameContentBg extends Vue.Component<FrameContentBgPropsI> {

    @Prop({
        type: Boolean,
        default: true
    })
    showCorner!: boolean

    @Prop({
        type: Boolean,
        default: false
    })
    radius!: boolean;

    @Prop({
        type: Boolean,
        default: false
    })
    loading!: boolean;

	render (h) {
		return (
			<div class={bem({radius: this.radius})}>
                <div v-if={this.showCorner} class={bem('corner')}></div>
                <div v-if={this.showCorner} class={bem('corner')}></div>
                <div v-if={this.showCorner} class={bem('corner')}></div>
                <div v-if={this.showCorner} class={bem('corner')}></div>
                <div class={bem('content')}>
                    {this.$slots.default}
                </div>
                <Spin size="large" fix v-show={this.loading}></Spin>
			</div>
		);
	}
}
